import React, { Dispatch, PropsWithChildren } from "react";
import { FC, useMemo } from "react";
import { StoreActionMap } from "./actions";
import { Store, StoreContext, StoreContextType, useStoreReducer } from "./initial";

export type Thunk = (dispatch: StoreContextType['dispatch'], state: Store) => void;
export type AugmentedDispatch = Dispatch<Thunk | StoreActionMap>;

export const augmentDispatch = (dispatch: Dispatch<StoreActionMap>, state: Store) =>
    (input: Thunk | StoreActionMap) => input instanceof Function ? input(dispatch, state) : dispatch(input);


export const StoreProvider: FC<PropsWithChildren> = ({children}) => {
    const [state, dispatch] = useStoreReducer();
    const contextValue = useMemo(() => ({ state, dispatch: augmentDispatch(dispatch, state) }), [state, dispatch]);

    return (
        <StoreContext.Provider value={contextValue}>
            {children}
        </StoreContext.Provider>
    );

};